import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import authReducer from "./authSlice";
import orderReducer from "./orderSlice";
import containerReducer from "./containerSlice";
import dashboardReducer from "./dashboardSlice";
import noteReducer from "./noteSlice";
import announcementReducer from "./announcementSlice";

export const store = configureStore({
  reducer: {
    users: userReducer,
    auth: authReducer,
    orders: orderReducer,
    containers: containerReducer,
    dashboard: dashboardReducer,
    notes: noteReducer,
    announcements: announcementReducer,
  },
  devTools: process.env.NODE_ENV !== "production", // enable Redux devtools only in dev
});
